import { FC } from 'react';

import { clientConfig } from '@/config/client';

import { usePlayerAnalytics } from '../../../hooks/tracker/use-player-analytics';
import { useCurrentEpisode } from '../../../../episode-player/hooks/use-current-episode';
import { useEpisodeHistory } from '../../../hooks/tracker/use-episode-history';
import { useInitEpisodeTracker } from '../../../../episode-player/hooks/use-init-episode-tracker';
import { useEpisodePrerollAnalytics } from '../../../../episode-player/hooks/use-episode-preroll-analytics';
import { useEpisodeCurrentStream } from '../../../../episode-player/hooks/use-episode-current-stream';

const { yandexMetrika } = clientConfig;

interface Props {
    contentId: string;
    psid: string;
}

export const EpisodePlayerTracker: FC<Props> = ({ contentId, psid }) => {
    const currentStream = useEpisodeCurrentStream(contentId);
    const currentEpisode = useCurrentEpisode(contentId);
    const tvSeriesContentId = currentEpisode?.tvSeries?.contentId ?? '';

    useInitEpisodeTracker(contentId, yandexMetrika);
    usePlayerAnalytics({
        contentId,
        psid,
        manifestUrl: currentStream?.uri,
    });
    useEpisodeHistory({ contentId, tvSeriesContentId });
    useEpisodePrerollAnalytics(contentId);

    return null;
};
